import alert from '@/plugins/alert'
import { Bill, Lead } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    students: [],
    lead: {},
    bills: {}
  },
  actions: {
    async fetchLead ({ commit }, billId) {
      commit('setLead', await Lead.fetchOne(billId))
    },
    async fetchBill ({ commit }, billId) {
      commit('setBill', await Bill.fetchOne(billId))
    },
    async createBill ({ commit }, { data, options }) {
      const bill = await Bill.create(data, options)
      commit('setBill', bill)
      return bill
    },
    async createLead ({ commit }, { data, options }) {
      commit('setLead', await Lead.create(data, options))
    },
    async updateLead ({ commit, state }, { id, ...lead }) {
      try {
        await Lead.update(id, lead)
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeBill ({ commit }, id) {
      await Bill.remove(id)
      commit('removeBill', id)
      alert.success('Xóa thành công!')
    },
    setBill ({ commit, state }, bill) {
      // commit('setBill', bill)
    },
    setStudents ({ commit, state }, students) {
      commit('setStudents', students)
    },
    async updateBill ({ commit, state }, { id, ...bill }) {
      try {
        commit('setBill', await Bill.update(id, bill))
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setBill (state, bill) {
      // state.bill = bill
    },
    setStudents (state, students) {
      state.students = students
    },
    setLead (state, lead) {
      // state.lead = lead
    },
    removeBill (state, billId) {
      delete state.bills[billId]
      state.bills = { ...state.bills }
    }
  },
  getters: {
    bill: (state) => {
      return state.bill
    },
    lead: (state) => {
      return state.lead
    }
  }
}
